import { Button, Icon } from 'native-base'
import { WhatsappLogo } from 'phosphor-react-native'
import React, { useCallback } from 'react'

import { useOpenUrl } from '../../../../hooks/use-open-url'
import { useWhatsappSupport } from '../../../../hooks/use-whatsapp-support'

export const WhatsappSupportButton = () => {
  const { openUrl } = useOpenUrl()
  const { whatsappUrl } = useWhatsappSupport()

  const openWhatsapp = useCallback(async () => {
    if (!whatsappUrl) {
      console.error('No support WhatsApp number found')
      return
    }

    await openUrl(whatsappUrl)
  }, [whatsappUrl, openUrl])

  return (
    <Button
      onPress={openWhatsapp}
      leftIcon={<Icon as={<WhatsappLogo color="currentColor" />} size="md" color={'white'} />}
    >
      WhatsApp
    </Button>
  )
}
